export default "__VITE_ASSET__Qd6bKbRq__"